<template>
  <!-- タブボタン部分 -->
  <div class="row_btn_status">
    <div v-if="loginUserInfo.auth_ref_estimate">
      <span v-if="active === 'request_status01'" class="btn btn-lg btn-request">
        見積依頼状況
      </span>
      <a
        v-else
        href="#"
        class="btn btn-lg btn-request"
        @click.prevent="
          submitAsteria(
            'RequestStateEstimate',
            'loadHTML_forRequestStateEstimate',
            {},
            '',
            '/requeststate/estimate.html'
          )
        "
        >見積依頼状況</a
      >
    </div>
    <div v-if="loginUserInfo.auth_ref_samplecatalogue">
      <span v-if="active === 'request_status02'" class="btn btn-lg btn-request">
        サンプル依頼状況
      </span>
      <a
        v-else
        href="#"
        class="btn btn-lg btn-request"
        @click.prevent="
          submitAsteria(
            'RequestStateSampleCatalogue',
            'loadHTML_forRequestStateSampleCatalogue',
            {},
            '',
            '/requeststate/samplecatalogue.html'
          )
        "
        >サンプル依頼状況</a
      >
    </div>
    <div v-if="loginUserInfo.auth_ref_envdocument">
      <span v-if="active === 'request_status03'" class="btn btn-lg btn-request">
        環境依頼状況
      </span>
      <a
        v-else
        href="#"
        class="btn btn-lg btn-request"
        @click.prevent="
          submitAsteria(
            'RequestStateEnvironment',
            'loadHTML_forRequestStateEnvironment',
            {},
            '',
            '/requeststate/environment.html'
          )
        "
        >環境依頼状況</a
      >
    </div>
  </div>
</template>

<script>
import { store as loginUserStore } from "../../store/LoginUser";

export default {
  props: {
    active: { props: String, required: true }
  },

  computed: {
    loginUserInfo() {
      return loginUserStore.info;
    }
  }
};
</script>
